import { useCallback, useMemo, useState } from "react";
import { ClickAwayListener, Tooltip, TooltipProps } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { medText } from "reports/constants/colors";

interface StyleProps {
  popperStyles?: React.CSSProperties;
  scale?: number | null;
}
const useStyles = makeStyles<any, StyleProps>({
  popper: props => ({
    ...(props.popperStyles ?? {}),
  }),
  tooltip: props => ({
    ...(props.scale ? { transform: `scale(${props.scale}) !important` } : {}),
    transformOrigin: "center top",
    margin: 0,
    backgroundColor: "#fff",
    color: medText,
    fontSize: 18,
    boxShadow: BOX_SHADOW_TOOLTIP,
    maxWidth: "unset",
  }),
});

export const HtmlTooltip = ({
  title,
  children,
  scale,
  enterTouchDelay,
  enterDelay,
  openOnMouseover = false,
  leaveDelay = 0,
  popperStyles,
  ...TooltipProps
}: {
  title: string | React.JSX.Element;
  children: React.JSX.Element;
  scale?: number | null;
  enterTouchDelay?: number | null;
  enterDelay?: number | null;
  openOnMouseover?: boolean;
  leaveDelay?: number | null;
  popperStyles?: React.CSSProperties;
} & Partial<TooltipProps>) => {
  const [open, setOpen] = useState(false);

  const classes = useStyles({
    popperStyles,
    scale,
  });

  const handleClickAway = useCallback(() => {
    if (open) {
      setOpen(false);
    }
  }, [open]);
  const tooltipProps = useMemo(() => {
    return enterDelay === undefined
      ? {
          open,
          onClick: e => {
            e.stopPropagation();
            setOpen(!open);
          },
        }
      : {
          enterDelay,
        };
  }, [enterDelay, open]);
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <span
        style={{ width: "100%", height: "fit-content", display: "inherit" }}
      >
        <Tooltip
          // if enterDelay prop is undefined, click to open/close
          // if enterDelay is specified, mouseover to open as usual
          {...tooltipProps}
          enterTouchDelay={Number(enterTouchDelay)}
          leaveDelay={Number(leaveDelay)}
          classes={{ popper: classes.popper, tooltip: classes.tooltip }}
          title={title as string}
          {...TooltipProps}
        >
          {children}
        </Tooltip>
      </span>
    </ClickAwayListener>
  );
};

const BOX_SHADOW_TOOLTIP = `4px 7px 6px 0px rgba(0, 0, 0, 0.14), -2px 5px 10px 3px rgba(0, 0, 0, 0.04), 3px -3px 12px 6px rgba(0, 0, 0, 0.05)`;
